import { render, staticRenderFns } from "./riskRecord.vue?vue&type=template&id=1d816b98&scoped=true&"
import script from "./riskRecord.vue?vue&type=script&lang=js&"
export * from "./riskRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d816b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d816b98')) {
      api.createRecord('1d816b98', component.options)
    } else {
      api.reload('1d816b98', component.options)
    }
    module.hot.accept("./riskRecord.vue?vue&type=template&id=1d816b98&scoped=true&", function () {
      api.rerender('1d816b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/riskRecord.vue"
export default component.exports